import CanvasChart from "./Chart.jsx";

import BarChartContent from "./BarChart.jsx";
import LineChartContent from "./LineChart.jsx";
import PieChartContent from "./PieChart.jsx";

import PropTypes from 'prop-types';

import React from "react";

const Charts = {
    BarChart: CanvasChart(BarChartContent),
    LineChart: CanvasChart(LineChartContent),
    PieChart: CanvasChart(PieChartContent)
};

export class ChartSelector extends React.PureComponent {
    static propTypes = {
        type: PropTypes.string
    };

    getWrappedInstance() {
        return this.chart;
    }

    render() {
        let Chart = Charts[this.props.type];
        if (!Chart) {
            throw new Error("Invalid chart type", this.props.type);
        }

        return <Chart ref={el => this.chart = el} {...this.props}/>;
    }
}

export default Charts;




// WEBPACK FOOTER //
// ./src/kpi/charts/index.js